import './HomeNav.css';
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import useVisible from '../hooks/useVisible';
import logo from '../img/KC-logo.svg';

function HomeNav() {
   const mainNav = useRef();

   const handleMove = e => {
      e.preventDefault();
      mainNav.current.scrollLeft += e.deltaY;
   }
   
   const visible = useVisible(15);

   return (
      <>
         <Helmet>
            <title>Kamp Christy - Cabin Rental on Gull Lake, Minnesota</title>
            <meta name="description" content="Book a cozy cabin on Upper Gull Lake in Lake Shore, Minnesota. Private beach, 2 docks, kayaks, fire pit, and stunning lake views. Sleeps 10+. Rentals May through October." />
            <link rel="canonical" href="https://kampchristy.com/" />
            <meta property="og:title" content="Kamp Christy - Cabin Rental on Gull Lake, Minnesota" />
            <meta property="og:description" content="Book a cozy cabin on Upper Gull Lake in Lake Shore, Minnesota. Private beach, 2 docks, kayaks, fire pit, and stunning lake views. Sleeps 10+." />
            <meta property="og:url" content="https://kampchristy.com/" />
         </Helmet>

         <motion.header
            className="logo"

            initial={{ opacity: 0, y: '100%' }}
				animate={visible ? {opacity: 0, y: -25} : {opacity: 1, y: 0} }
				transition={{ duration: .3, ease: 'easeInOut' }}
         >
            <div className="top-shadow" />
            <h1 className="sr-only">Kamp Christy - Cabin Rental on Gull Lake, Minnesota</h1>
            <img src={logo} alt="KC Logo" fetchPriority="high" width="192" height="192" />
         </motion.header>

         <motion.main
            className="slider"
            ref={mainNav}
            onWheel={handleMove}

            initial={{ opacity: 0, y: '100%' }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: .6, ease: 'easeInOut' }}
         >
            <nav id="navbar">
               <ul>
                  <li>
                     <Link to='/about-us'>
                        <section>
                           <h2>About Kamp Christy</h2>
                           <p className="badge">our little story</p>
                        </section>

                        <footer>
                           <FontAwesomeIcon icon={solid('store')} />
                           <h3>The Cabin Life</h3>
                           <p>Lake Life</p>
                        </footer>
                     </Link>
                  </li>

                  <li>
                     <Link to='/team'>
                        <section>
                           <h2>Team</h2>
                           <p className="badge">a great crew</p>
                        </section>

                        <footer>
                           <FontAwesomeIcon icon={solid('users')} />
                           <h3>We are a family</h3>
                           <p>We love what we do</p>
                        </footer>
                     </Link>
                  </li>

                  <li>
                     <Link to='/gallery'>
                        <section>
                           <h2>Gallery</h2>
                           <p className="badge">look here</p>
                        </section>

                        <footer>
                           <FontAwesomeIcon icon={solid('eye')} />
                           <h3>See for yourself</h3>
                           <p>While we are at work</p>
                        </footer>
                     </Link>
                  </li>

                  <li>
                     <Link to='/contact'>
                        <section>
                           <h2>Contact us</h2>
                           <p className="badge">leave a message</p>
                        </section>

                        <footer>
                           <FontAwesomeIcon icon={solid('phone')} />
                           <h3>Get in Touch</h3>
                           <p>We will get back to you!</p>
                        </footer>
                     </Link>
                  </li>
               </ul>
            </nav>
         </motion.main>
      </>
   );
}

export default HomeNav;